import { z } from "zod";

export const getFileSchema = z.object({
	fileId: z.uuid(),
});

export const getFileBatchJsonSchema = z.object({
	fileIds: z.preprocess((data) => {
		if (Array.isArray(data)) return data;
		if (typeof data === "string") return [data];
	}, z.array(z.uuid())),
});
